/**
 * Three layout states (ENG-2281), mobile-first.
 *
 * Values follow the 2026 de-facto scale (Tailwind / common device ranges):
 *   https://webhelpagency.com/blog/responsive-breakpoints/
 *
 *   mobile  — base, no query          phones, portrait tablets, narrow windows
 *   laptop  — 64em (1024px)           small laptops, iPad landscape
 *   desktop — 80em (1280px)           standard monitors
 *
 * `em` so layout tracks the user's browser font-size (zoom/text-only zoom).
 * Media-query `em` uses the *initial* font size, not our fluid `html` rem, so
 * density and layout stay independent.
 *
 * Chakra aliases (`sm`/`md`/`lg`/`xl`) map onto this scale so existing
 * `{{ md: 2, lg: 3 }}` grids keep working:
 *   sm = 40em (640)  phones landscape / small tablet
 *   md = 48em (768)  tablet — undisputed edge in the guide
 *   lg = laptop
 *   xl = desktop
 *
 * New code should use `useLayout()` / `layout.laptop` / `layout.desktop`.
 */
export const breakpoints = {
	sm: '40em',
	md: '48em',
	lg: '64em',
	xl: '80em',
	'2xl': '96em',
} as const;

export const layout = {
	mobile: 'base',
	laptop: 'lg',
	desktop: 'xl',
} as const;

export type Layout = 'mobile' | 'laptop' | 'desktop';

/** Exclusive upper bound of the mobile layout (just under laptop). */
export const overlayNavMaxWidthEm = 63.99;

export default breakpoints;
